import SalaryAllowanceConstants from "../constants/salary-allowance-constants";
import airticketAllowanceService from "../services/SalaryAllowance/airticket-allowance-service";
import employeeInsuranceService from "../services/SalaryAllowance/employee-insurance-service";
import housingAllowanceService from "../services/SalaryAllowance/housing-allowance-service";
import insuranceLedgerService from "../services/SalaryAllowance/insurance-ledger-service";
import insuranceManagementService from "../services/SalaryAllowance/insurance-management-service";
import salaryHistoryService from "../services/SalaryAllowance/salary-history-service";
import salaryLedgerService from "../services/SalaryAllowance/salary-ledger-service";
import salaryManagementService from "../services/SalaryAllowance/salary-management-service";

// air ticket allowance
function changeAirticketAllowanceAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGEAIRTICKETALLOWANCE,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeAirticketAllowance (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeAirticketAllowanceAction(filters, status, counter));
}
export function selectAirticketAllowance (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		airticketAllowanceService.selectAirticketAllowance(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTAIRTICKETALLOWANCE,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeAirticketAllowanceAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeAirticketAllowanceAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeAirticketAllowanceAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateAirticketAllowance (puts, index, callback) {
	return dispatch => airticketAllowanceService.updateAirticketAllowance(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: SalaryAllowanceConstants.ActionTypes.UPDATEAIRTICKETALLOWANCE,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}

// employee insurance
function changeEmployeeInsuranceAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGEEMPLOYEEINSURANCE,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeEmployeeInsurance (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeEmployeeInsuranceAction(filters, status, counter));
}
export function selectEmployeeInsurance (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		employeeInsuranceService.selectEmployeeInsurance(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTEMPLOYEEINSURANCE,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeEmployeeInsuranceAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeEmployeeInsuranceAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeEmployeeInsuranceAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateEmployeeInsurance (puts, index, callback) {
	return dispatch => employeeInsuranceService.updateEmployeeInsurance(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: SalaryAllowanceConstants.ActionTypes.UPDATEEMPLOYEEINSURANCE,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}

// housing allowance
function changeHousingAllowanceAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGEHOUSINGALLOWANCE,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeHousingAllowance (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeHousingAllowanceAction(filters, status, counter));
}
export function selectHousingAllowance (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		housingAllowanceService.selectHousingAllowance(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTHOUSINGALLOWANCE,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeHousingAllowanceAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeHousingAllowanceAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeHousingAllowanceAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateHousingAllowance (puts, index, callback) {
	return dispatch => housingAllowanceService.updateHousingAllowance(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: SalaryAllowanceConstants.ActionTypes.UPDATEHOUSINGALLOWANCE,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}

// insurance ledger
function changeInsuranceLedgerAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGEINSURANCELEDGER,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeInsuranceLedger (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeInsuranceLedgerAction(filters, status, counter));
}
export function selectInsuranceLedger (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		insuranceLedgerService.selectInsuranceLedger(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTINSURANCELEDGER,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeInsuranceLedgerAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeInsuranceLedgerAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeInsuranceLedgerAction({}, "loading", 0))
			}
		}, 100);
	}
}

// insurance management
function changeInsuranceManagementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGEINSURANCEMANAGEMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeInsuranceManagement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeInsuranceManagementAction(filters, status, counter));
}
export function selectInsuranceManagement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		insuranceManagementService.selectInsuranceManagement(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTINSURANCEMANAGEMENT,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeInsuranceManagementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeInsuranceManagementAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeInsuranceManagementAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateInsuranceManagement(puts, index, callback) {
	return dispatch => insuranceManagementService.updateInsuranceManagement(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: SalaryAllowanceConstants.ActionTypes.UPDATEINSURANCEMANAGEMENT,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}

// salary history
function changeSalaryHistoryAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGESALARYHISTORY,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeSalaryHistory (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeSalaryHistoryAction(filters, status, counter));
}
export function selectSalaryHistory (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		salaryHistoryService.selectSalaryHistory(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTSALARYHISTORY,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeSalaryHistoryAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeSalaryHistoryAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeSalaryHistoryAction({}, "loading", 0))
			}
		}, 100);
	}
}

// salary ledger
function changeSalaryLedgerAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGESALARYLEDGER,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeSalaryLedger (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeSalaryLedgerAction(filters, status, counter));
}
export function selectSalaryLedger (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		salaryLedgerService.selectSalaryLedger(gets, res => {
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTSALARYLEDGER,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeSalaryLedgerAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeSalaryLedgerAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeSalaryLedgerAction({}, "loading", 0))
			}
		}, 100);
	}
}

// salary management 
function changeSalaryManagementAction (filters = {}, status = "loading", counter = 1) {
	return {
		type: SalaryAllowanceConstants.ActionTypes.CHANGESALARYMANAGEMENT,
		payload: {
			filters: filters,
			status: status,
			counter: counter
		}
	}
}
export function changeSalaryManagement (filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeSalaryManagementAction(filters, status, counter));
}
export function selectSalaryManagement (gets, callback) {
	let apiLoadStatus = false;
	return dispatch => {
		salaryManagementService.selectSalaryManagement(gets, res => {
			// console.log(res);
			apiLoadStatus = true;
			if (res.data.Success) {
				dispatch({
					type: SalaryAllowanceConstants.ActionTypes.SELECTSALARYMANAGEMENT,
					payload: {
						data: res.data.Object,
						status: "loaded"
					}
				});
			}else{
				dispatch(changeSalaryManagementAction({}, "error", 0));
			}
		}, err => {
			apiLoadStatus = true;
			dispatch(changeSalaryManagementAction({}, "error", 0))
		})
		let timeoutIndex = setTimeout(() => {
			clearTimeout(timeoutIndex);
			if (!apiLoadStatus) {
				dispatch(changeSalaryManagementAction({}, "loading", 0))
			}
		}, 100);
	}
}
export function updateSalaryManagement (puts, index, callback) {
	return dispatch => salaryManagementService.updateSalaryManagement(puts, res => {
		if ("function" === typeof callback) {
			callback(res);
		}
		if (res.data.Success) {
			dispatch({
				type: SalaryAllowanceConstants.ActionTypes.UPDATESALARYMANAGEMENT,
				payload: {
					data: puts,
					index: index
				}
			})
		}
	})
}



// WEBPACK FOOTER //
// ./src/actions/salary-allowance-actions.js